export const FEATURES = {
    commissionReport: 'commission-report',
    inventoryBlocks: 'inventory-blocks',
    roomForecast: 'forecast-rooms',
    revenueForecast: 'forecast-revenue',
    recommendationGainHistoric: 'recommendation-gain-historic',
    recommendationGainPotential: 'recommendation-gain-potential',
    cancellationReport: 'cancellation-report',
    comparisonReport: 'comparison-report',
    bookingsReport: 'bookings-report',
    pickupReport: 'pickup-report',
    segmentationReport: 'segmentation-report',
    groupDisplacementCalculator: 'group-displacement-calculator',
    costOfOccupiedRoomCalculator: 'cost-of-occupied-room-calculator',
    rateCalculator: 'rate-calculator',
    apaleoConnect: 'apaleo-connect',
    pmsBalancing: 'pms-balancing',
    cardinalRecommendations: 'cardinal-recommendations',
    pickupReportV2: 'pickup-report-v2',
    segmentForecast: 'segment-forecast',
    sellingRateReport: 'selling-rate-report',
    sellingRateEvolution: 'selling-rate-evolution',
    dashboardV2: 'dashboard-v2',
    rateChangeImpact: 'rate-change-impact',
    otaInsights: 'ota-insights',
    financeHub: 'finance-hub',
    financeHubGroups: 'finance-hub-groups',
    financeHubGroupsRevenue: 'finance-hub-groups-revenue',
    financeHubSleepers: 'finance-hub-sleepers',
    financeHubRoomsGuaranteed: 'finance-hub-rooms-guaranteed',
    financeHubRevenueGuaranteed: 'finance-hub-revenue-guaranteed',
    financeHubRoomsUnguaranteed: 'finance-hub-rooms-unguaranteed',
    financeHubRevenueUnguaranteed: 'finance-hub-revenue-unguaranteed',
    financeHubTotalRoomsGuaranteed: 'finance-hub-rooms-total-guaranteed',
    financeHubTotalRevenueGuaranteed: 'finance-hub-revenue-total-guaranteed',
    financeHubOccupancyGuaranteed: 'finance-hub-occupancy-guaranteed',
    financeHubADR: 'finance-hub-adr',
    financeHubRevPar: 'finance-hub-revpar',
    financeHubForecastRevenue: 'finance-hub-forecast-revenue',
    financeHubForecastRooms: 'finance-hub-forecast-rooms',
    financeHubBudgetRevenue: 'finance-hub-budget-revenue',
    financeHubBudgetRooms: 'finance-hub-budget-rooms',
    financeHubBusinessChange: 'finance-hub-business-change',
    financeHubSegment: 'finance-hub-segment',
    financeHubSegmentV2: 'finance-hub-segment-v2',
    financeHubLYSPITRooms: 'finance-hub-lyspit-rooms',
    financeHubLYSPITRevenue: 'finance-hub-lyspit-revenue',
    financeHubLYFinalRooms: 'finance-hub-lyfinal-rooms',
    financeHubLYFinalRevenue: 'finance-hub-lyfinal-revenue',
    financeHubOOORooms: 'finance-hub-ooo-rooms',
    financeHubSummary: 'finance-hub-summary',
    financeHubMonthlyTotals: 'finance-hub-monthly-totals',
    budgetCalculator: 'budget-calculator',
    sellingRateMassUpdate: 'selling-rate-mass-update',
    segmentBucketManagement: 'segment-bucket-management',
    otaRateCalendar: 'ota-rate-calendar',
    sellingRateCalendarRoomsSold: 'selling-rate-calendar-rooms-sold',
    sellingRateCalendarAdmin: 'selling-rate-admin',
    hibernateDatesManagement: 'hibernate-dates-management',
    otaCompsets: 'ota-compsets',
    fiscalBreakdownReport: 'fiscal-breakdown-report',
    recommendationReport: 'recommendation-report',
    scheduledEmailsManagement: 'scheduled-email-management',
    scheduledEmailsPerfReport: 'scheduled-email-perf-report',
    scheduledEmailsSalesReport: 'scheduled-email-sales-report',
    otaParity: 'ota-parity',
    roomManagement: 'room-management',
    groupPickupReport: 'group-pickup-report',
    guestrevu: 'guestrevu',
    settingsCalendar: 'settings-calendar',
    roomRatePriceLimitsManagement: 'room-rates-price-limit-management',
    autoAcceptConfigManagement: 'auto-accept-config-management',
    derivedRoomsConfigManagement: 'derived-rooms-config-management',
    autoAcceptEnableConfigManagement: 'auto-accept-enable-management',
    notes: 'notes',
    propertyManagement: 'property-management',
    derivationChangeAdmin: 'derivation-change-admin',
    customisedReport: 'customised-report',
    events: 'events',
    hurdleRackAdvisor: 'hurdle-rack-advisor',
    rateCodeManagement: 'rate-code-management',
    revenueGain: 'revenue-gain',
    otaChannelAlerts: 'ota-channel-alerts',
    demandCalendar: 'demand-calendar',
    statistics: 'statistics',
    revflow: 'revflow',
    viewAERecs: 'view-ae-recs',
    sellingRateTabular: 'selling-rate-tabular',
    actionMultipleRecs: 'action-multiple-recs',
    exportAllRecommendations: 'export-all-recommendations',
    viewNotifications: 'view-notifications',
    openCloseRates: 'open-close-rates',
    reservationsUpload: 'reservations-upload',
    componentRoomsManagement: 'component-rooms-management',
    budgetCreator: 'budget-creator',
};
